namespace GeniuzPOS.Lookups {
    export interface VwpsShopGroupRow {
        Id?: number;
        ShopGroupId?: string;
        ShopGroupName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace VwpsShopGroupRow {
        export const idProperty = 'ShopGroupId';
        export const nameProperty = 'ShopGroupId';
        export const localTextPrefix = 'Lookups.VwpsShopGroup';
        export const lookupKey = 'VwpsShopGroupRow';

        export function getLookup(): Q.Lookup<VwpsShopGroupRow> {
            return Q.getLookup<VwpsShopGroupRow>('VwpsShopGroupRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShopGroupId = "ShopGroupId",
            ShopGroupName = "ShopGroupName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
